import { animations } from './animations';
import { colorSchemes } from './colorSchemes';

const size = 10;
const gap = 4;
const resizeDebounceMs = 150;

const activeAnimationName = 'puzzle';
// const activeAnimationName = 'horizontalWave';

// const activeColorSchemeName = 'rainbow';
// const activeColorSchemeName = 'gray';
// const activeColorSchemeName = 'gray_plus';
const activeColorSchemeName = 'gray_plus_03';
// const activeColorSchemeName = 'yellow';

function initCanvasAnimation(stage) {
  const colors = colorSchemes[activeColorSchemeName];
  const animation = animations[activeAnimationName];
  const ctx = stage.getContext('2d');

  let stageWidth = 0;
  let stageHeight = 0;
  let cols = 0;
  let rows = 0;
  let squares = [];

  function buildGrid() {
    const dpr = window.devicePixelRatio || 1;

    stageWidth = stage.clientWidth;
    stageHeight = stage.clientHeight;

    stage.width = stageWidth * dpr;
    stage.height = stageHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    cols = Math.round((stageWidth + gap) / (size + gap));
    rows = Math.round((stageHeight + gap) / (size + gap));

    squares = [];
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        const square = {
          row,
          col,
          x: col * (size + gap),
          y: row * (size + gap),
          color: colors[Math.floor(Math.random() * colors.length)],
        };
        animation.setup(square, cols, rows, animation.config);
        squares.push(square);
      }
    }
  }

  buildGrid();

  let resizeTimeout;
  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(buildGrid, resizeDebounceMs);
  }
  window.addEventListener('resize', handleResize);

  let animationFrameId;
  function frame(now) {
    const time = now / 1000;

    ctx.clearRect(0, 0, stageWidth, stageHeight);

    for (const square of squares) {
      ctx.globalAlpha = animation.getOpacity(square, time, cols, rows, animation.config);
      ctx.fillStyle = square.color;
      ctx.fillRect(square.x, square.y, size, size);
    }

    animationFrameId = requestAnimationFrame(frame);
  }

  animationFrameId = requestAnimationFrame(frame);

  return function cleanup() {
    window.removeEventListener('resize', handleResize);
    clearTimeout(resizeTimeout);
    cancelAnimationFrame(animationFrameId);
  };
}

export { initCanvasAnimation };
